import angular from 'angular';
import uiRouter from 'angular-ui-router';
import nbuComponent from './nbu.component';

let nbuModule = angular.module('nbu', [
  uiRouter
])

.component('nbu', nbuComponent)

.name;

export default nbuModule;



// WEBPACK FOOTER //
// ./client/app/common/forms/nbu/nbu.js